import { config as developmentConfig } from './config.development'
import { config as productionConfig } from './config.production'
import { config as stagingConfig } from './config.staging'

interface Config {
  apiBaseUrl: string
  protocol: string
  websocketProtocol: string
  isProduction: boolean
  isStaging: boolean
}

const environment = String(import.meta.env['VITE_ENV'] ?? import.meta.env['VITE_VERCEL_ENV'] ?? '')
let envConfig: Config = developmentConfig
if (environment === 'production') {
  envConfig = productionConfig
} else if (environment === 'staging' || environment === 'preview') {
  envConfig = stagingConfig
}

export const config = {
  apiUrl: `${envConfig.protocol}://${envConfig.apiBaseUrl}/api/v1`,
  graphqlApiUrl: `${envConfig.protocol}://${envConfig.apiBaseUrl}/graphql`,
  subscriptionsUrl: `${envConfig.websocketProtocol}://${envConfig.apiBaseUrl}/subscriptions`,
  isProduction: envConfig.isProduction,
  isStaging: envConfig.isStaging,
}
